import { render, staticRenderFns } from "./folders-and-files.vue?vue&type=template&id=1ebd9915&scoped=true"
import script from "./folders-and-files.vue?vue&type=script&lang=js"
export * from "./folders-and-files.vue?vue&type=script&lang=js"
import style0 from "./folders-and-files.vue?vue&type=style&index=0&id=1ebd9915&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ebd9915",
  null
  
)

export default component.exports